
 export const Get_Teams = [
    { id: 'team_default', value: '' },
    { id: 'staq_phd', value: 'STAQ PhD' },
    { id: 'automaters', value: 'Automaters' }
]

    
